import { __assign } from "tslib";
/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { $el, bind, getBooleanTypeAttr, getNumTypeAttr, getStrTypeAttr, removeAttrs, setCss, setHtml } from '../../dom-utils';
import { clickoutside, CssTransition, _arrow, _Popper } from '../../mixins';
import { type, validComps } from '../../utils';
import PREFIX from '../prefix';
var STATEKEY = 'visibleState';
var DEFAULTDELAY = 80;
var VISIBLETIMER = null, EVENTTIMER = null;
var Poptip = /** @class */ (function () {
    function Poptip() {
        this.VERSION = 'v2.0';
        this.COMPONENTS = $el('r-poptip', { all: true });
        this._create(this.COMPONENTS);
        _arrow.scrollUpdate();
    }
    Poptip.prototype.config = function (el) {
        var target = $el(el);
        validComps(target, 'poptip');
        var _a = Poptip.prototype, _attrs = _a._attrs, _setVisible = _a._setVisible, _handleTrigger = _a._handleTrigger;
        var _b = _attrs(target), trigger = _b.trigger, title = _b.title, content = _b.content, disabled = _b.disabled, placement = _b.placement, offset = _b.offset, confirm = _b.confirm;
        var PoptipRefElem = target.querySelector("." + PREFIX.poptip + "-rel");
        var PoptipPopper = target.querySelector("." + PREFIX.poptip + "-popper");
        var PoptipTitle = target.querySelector("." + PREFIX.poptip + "-title");
        var PoptipContent = target.querySelector("." + PREFIX.poptip + "-body-content");
        return {
            get visible() {
                return PoptipPopper.dataset[STATEKEY] === 'show';
            },
            set visible(newVal) {
                if (newVal && !type.isBol(newVal))
                    return;
                _setVisible(newVal, PoptipRefElem, PoptipPopper, placement, offset);
            },
            get disabled() {
                return disabled;
            },
            set disabled(newVal) {
                if (newVal && !type.isBol(newVal))
                    return;
                _handleTrigger(trigger, confirm, newVal, target, PoptipRefElem, PoptipPopper, placement, offset);
            },
            get title() {
                return title;
            },
            set title(newVal) {
                if (newVal && !type.isStr(newVal))
                    return;
                setHtml(PoptipTitle, newVal);
            },
            get content() {
                return content;
            },
            set content(newVal) {
                if (newVal && !type.isStr(newVal))
                    return;
                setHtml(PoptipContent, newVal);
            },
            events: function (_a) {
                var onPopperShow = _a.onPopperShow, onPopperHide = _a.onPopperHide, onOk = _a.onOk, onCancel = _a.onCancel;
                var visibleEvent = function (show) {
                    if (show) {
                        onPopperShow && type.isFn(onPopperShow);
                    }
                    else {
                        onPopperHide && type.isFn(onPopperHide);
                    }
                };
                var toogleEv = function () {
                    setTimeout(function () {
                        PoptipPopper.dataset[STATEKEY] === 'show'
                            ? visibleEvent(true)
                            : visibleEvent(false);
                    }, 200);
                };
                var clickoutsideEv = function () {
                    if (PoptipPopper.style.visibility === 'visible') {
                        setTimeout(function () { return visibleEvent(false); }, DEFAULTDELAY);
                    }
                };
                if (!confirm) {
                    if (trigger === 'hover') {
                        bind(target, 'mouseenter', function () {
                            if (EVENTTIMER)
                                clearTimeout(EVENTTIMER);
                            EVENTTIMER = setTimeout(function () { return visibleEvent(true); }, DEFAULTDELAY);
                        });
                        bind(target, 'mouseleave', function () {
                            if (EVENTTIMER)
                                clearTimeout(EVENTTIMER);
                            if (PoptipPopper.dataset[STATEKEY] === 'show')
                                setTimeout(function () { return visibleEvent(false); }, DEFAULTDELAY);
                        });
                    }
                    if (trigger === 'focus') {
                        bind(PoptipRefElem, 'mousedown', function () { return visibleEvent(true); });
                        bind(PoptipRefElem, 'mouseup', function () { return visibleEvent(false); });
                    }
                }
                if (trigger === 'click' || trigger === 'focus') {
                    clickoutside(target, clickoutsideEv);
                }
                if (trigger === 'click') {
                    bind(PoptipRefElem, 'click', toogleEv);
                }
                if (confirm) {
                    var PoptipOkBtn = PoptipPopper.querySelector("." + PREFIX.button + "-primary");
                    var PoptipCancelBtn = PoptipPopper.querySelector("." + PREFIX.button + "-text");
                    bind(PoptipOkBtn, 'click', function () { return onOk && type.isFn(onOk); });
                    bind(PoptipCancelBtn, 'click', function () { return onCancel && type.isFn(onCancel); });
                }
            }
        };
    };
    Poptip.prototype._create = function (COMPONENTS) {
        var _this = this;
        COMPONENTS.forEach(function (node) {
            var ReferenceElem = node.firstElementChild || node.innerHTML;
            var _a = _this._attrs(node), trigger = _a.trigger, title = _a.title, content = _a.content, placement = _a.placement, padding = _a.padding, offset = _a.offset, confirm = _a.confirm, visible = _a.visible, width = _a.width, wordWrap = _a.wordWrap, disabled = _a.disabled, okText = _a.okText, cancelText = _a.cancelText;
            _this.setMainTemplate(node, title, content, placement);
            var PoptipRel = node.querySelector("." + PREFIX.poptip + "-rel");
            var PoptipPopper = node.querySelector("." + PREFIX.poptip + "-popper");
            _this.addReferenceElem(PoptipRel, ReferenceElem);
            _this.setConfirmTemplate(confirm, node, title, okText, cancelText);
            _this._setPlacement(PoptipRel, PoptipPopper, placement, offset);
            _this._setVisible(visible, PoptipRel, PoptipPopper, placement, offset);
            _this._setPadding(node, padding);
            _this._setWidthAndWordWrap(PoptipPopper, width, wordWrap);
            _this._handleTrigger(trigger, confirm, disabled, node, PoptipRel, PoptipPopper, placement, offset);
            _this._handleBtnClick(PoptipRel, PoptipPopper, placement, offset);
            removeAttrs(node, [
                'width',
                'title',
                'offset',
                'content',
                'confirm',
                'visible',
                'padding',
                'disabled',
                'trigger',
                'placement',
                'word-wrap',
                'ok-text',
                'cancel-text'
            ]);
        });
    };
    Poptip.prototype.setMainTemplate = function (node, title, content, placement) {
        var template = "\n         <div class=\"" + PREFIX.poptip + "-rel\"></div>\n         <div class=\"" + PREFIX.poptip + "-popper\" x-placement=\"" + placement + "\">\n             <div class=\"" + PREFIX.poptip + "-content\">\n                 <div class=\"" + PREFIX.poptip + "-arrow\"></div>\n                 <div class=\"" + PREFIX.poptip + "-inner\">\n                    " + (title ? "<div class=\"" + PREFIX.poptip + "-title\">" + title + "</div>" : '') + "\n                     <div class=\"" + PREFIX.poptip + "-body\">\n                         <div class=\"" + PREFIX.poptip + "-body-content\">" + content + "</div>\n                     </div>\n                 </div>\n             </div>\n         </div>\n        ";
        setHtml(node, template);
    };
    Poptip.prototype.addReferenceElem = function (child, ReferenceElem) {
        if (typeof ReferenceElem === 'string') {
            setHtml(child, ReferenceElem);
        }
        else if (ReferenceElem instanceof Element) {
            child.appendChild(ReferenceElem);
        }
    };
    Poptip.prototype.setConfirmTemplate = function (confirm, node, title, okText, cancelText) {
        if (!confirm)
            return;
        var template = "\n         <i class=\"" + PREFIX.icon + " " + PREFIX.icon + "-ios-help-circle\"></i>\n         <div class=\"" + PREFIX.poptip + "-body-message\">" + title + "</div>\n         <div class=\"" + PREFIX.poptip + "-footer\">\n            <button type=\"button\" class=\"" + PREFIX.button + " " + PREFIX.button + "-text " + PREFIX.button + "-sm\">" + cancelText + "</button>\n            <button type=\"button\" class=\"" + PREFIX.button + " " + PREFIX.button + "-primary " + PREFIX.button + "-sm\">" + okText + "</button>\n         </div>\n        ";
        var PoptipBody = node.querySelector("." + PREFIX.poptip + "-body");
        setHtml(PoptipBody, template);
        node.querySelector("." + PREFIX.poptip + "-title").remove();
        node.classList.add(PREFIX.poptip + "-confirm");
    };
    Poptip.prototype._handleTrigger = function (type, confirm, disabled, node, refElem, popper, placement, offset) {
        var _this = this;
        if (disabled)
            return;
        var show = function (show, e) {
            if (e)
                e.stopPropagation();
            _this._setVisible(show, refElem, popper, placement, offset);
        };
        if (!confirm) {
            if (type === 'hover') {
                bind(node, 'mouseenter', function (e) {
                    if (VISIBLETIMER)
                        clearTimeout(VISIBLETIMER);
                    if (popper.dataset[STATEKEY] === 'show')
                        return;
                    VISIBLETIMER = setTimeout(function () { return show(true, e); }, DEFAULTDELAY);
                });
                bind(node, 'mouseleave', function (e) {
                    if (VISIBLETIMER)
                        clearTimeout(VISIBLETIMER);
                    if (popper.dataset[STATEKEY] === 'show')
                        setTimeout(function () { return show(false, e); }, DEFAULTDELAY);
                });
            }
            if (type === 'focus') {
                bind(refElem, 'mousedown', function (e) { return show(true, e); });
                bind(refElem, 'mouseup', function (e) { return show(false, e); });
            }
        }
        if (type === 'click') {
            var hide = function () {
                if (popper.dataset[STATEKEY] === 'close')
                    return;
                show(false);
            };
            var clickEv_1 = function (e) {
                var poppers = document.querySelectorAll("." + PREFIX.poptip + "-popper");
                poppers.forEach(function (child) {
                    var otherPopper = child;
                    if (otherPopper.dataset[STATEKEY] === 'show') {
                        _this._setVisible(false, refElem, otherPopper, placement, offset);
                    }
                });
                popper.style.visibility === 'visible' ? show(false, e) : show(true, e);
            };
            clickoutside(node, hide);
            bind(refElem, 'click', function (e) { return clickEv_1(e); });
        }
    };
    Poptip.prototype._handleBtnClick = function (refElem, popper, placement, offset) {
        var _this = this;
        var PoptipOkBtn = popper.querySelector("." + PREFIX.button + "-primary");
        var PoptipCancelBtn = popper.querySelector("." + PREFIX.button + "-text");
        if (!PoptipOkBtn)
            return;
        var hidden = function () { return _this._setVisible(false, refElem, popper, placement, offset); };
        bind(PoptipOkBtn, 'click', hidden);
        bind(PoptipCancelBtn, 'click', hidden);
    };
    Poptip.prototype._setVisible = function (visible, refElem, popper, placement, offset) {
        var _a = Poptip.prototype, _setPlacement = _a._setPlacement, _visibleTransition = _a._visibleTransition;
        if (visible) {
            popper.dataset[STATEKEY] = 'show';
            _visibleTransition('in', popper);
            _setPlacement(refElem, popper, placement, offset);
        }
        else {
            popper.dataset[STATEKEY] = 'close';
            setTimeout(function () {
                popper.dataset[STATEKEY] === 'close' && _visibleTransition('out', popper);
            }, 0);
        }
    };
    Poptip.prototype._setPlacement = function (refElem, popper, placement, offset) {
        _Popper._newCreatePopper(refElem, popper, placement, offset);
    };
    Poptip.prototype._visibleTransition = function (type, popper) {
        var aniCls = type === 'in'
            ? { enterCls: 'zoom-big-fast-enter' }
            : { leaveCls: 'zoom-big-fast-leave' };
        CssTransition(popper, __assign(__assign({ inOrOut: type }, aniCls), { rmCls: true, timeout: 190 }));
    };
    Poptip.prototype._setWidthAndWordWrap = function (child, width, wordWrap) {
        setCss(child, 'width', width + "px");
        if (!wordWrap)
            return;
        var PoptipBodyContent = child.querySelector("." + PREFIX.poptip + "-body-content");
        PoptipBodyContent.classList.add(PREFIX.poptip + "-body-content-word-wrap");
    };
    Poptip.prototype._setPadding = function (node, padding) {
        if (!padding)
            return;
        setCss(node.querySelector("." + PREFIX.poptip + "-title"), 'padding', padding);
        setCss(node.querySelector("." + PREFIX.poptip + "-body"), 'padding', padding);
    };
    Poptip.prototype._attrs = function (node) {
        return {
            width: getNumTypeAttr(node, 'width', -1),
            offset: getNumTypeAttr(node, 'offset', 0),
            title: getStrTypeAttr(node, 'title', ''),
            okText: getStrTypeAttr(node, 'ok-text', '确定'),
            content: getStrTypeAttr(node, 'content', ''),
            trigger: getStrTypeAttr(node, 'trigger', 'click'),
            padding: getStrTypeAttr(node, 'padding', ''),
            placement: getStrTypeAttr(node, 'placement', 'top'),
            cancelText: getStrTypeAttr(node, 'cancel-text', '取消'),
            confirm: getBooleanTypeAttr(node, 'confirm'),
            visible: getBooleanTypeAttr(node, 'visible'),
            disabled: getBooleanTypeAttr(node, 'disabled'),
            wordWrap: getBooleanTypeAttr(node, 'word-wrap')
        };
    };
    return Poptip;
}());
export default Poptip;
